const prefix = '/MODULE-COLLECT'

export default {
  // 获取客户端栏目和模型
  getClientData: `${prefix}/collect/client/x2/getClientData`,
  // 校验任务名称是否重复
  fetchNameCheck: `${prefix}/collectTaskExt/checkName`,
  // 字段列表
  collectFiledList: `${prefix}/collectitem`,
  // 任务列表
  collectTask: `${prefix}/collectTasks`,
  // 校验名称
  collectTaskUnique: `${prefix}/collectTasks/unique/name`,
  // 采集模板列表
  collectTemplateList: `${prefix}/collecttpls/list`,
  // 采集模板详情
  collectTemplate: `${prefix}/collecttpls`,
  // 开始采集任务
  collectStart: `${prefix}/collectTasks/saveAndStart`,
  // 重新开始采集任务
  collectUpdate: `${prefix}/collectTasks/updateAndStart`,
  // 暂停采集任务
  collectPause: `${prefix}/collectTasks/pause`,
  // 恢复采集任务
  collectRecover: `${prefix}/collectTasks/resume`,
  // 停止采集任务
  collectStop: `${prefix}/collectTasks/terminate`,
  // 查看任务/修改任务 开始采集
  collectTasksStart: `${prefix}/collectTasks/start`,
  // 自定义采集 URL 分析
  collectAnalysisUrl: `${prefix}/collectTasks/analysis/byUrl`,
  // 自定义采集 保存任务
  collectCustomTaskExt: `${prefix}/collectTaskExt`,
  // 自定义采集 创建任务并开始
  collectCustomTaskExtStart: `${prefix}/collectTaskExt/saveAndStart`,
  // 自定义采集 修改任务
  collectCustomTaskExtPut: `${prefix}/collectTaskExt`,
  // 自定义采集 修改任务并开始
  collectCustomTaskExtStartPut: `${prefix}/collectTaskExt/updateAndStart`,
  // 自定义采集 选择字段 获取采集结果
  collectCustomTaskListElement: `${prefix}/collectTasks/customListElement`,
  // 自定义采集 深入采集元素分析
  collectCustomTaskElement: `${prefix}/collectTasks/customElement`,
  // 自定义采集 获取深入采集元素数据
  collectCustomTaskElementForDeep: `${prefix}/collectTasks/customElementForDeep`,
  // 自定义采集 根据字段获取深入采集数据
  collectCustomTaskElementForBatch: `${prefix}/collectTasks/customElementForBatch`
}
